export const footer = {
  'All rights reserved': 'All rights reserved',
  'FooterMoto': 'Decreasing fraud in financial markets by developing efficient fraud detection and prevention systems',
}

export default footer
